import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";

export function ThemeToggle() {
  const { mode, toggleMode } = useTheme();
  const isDark = mode === "dark";
  const currentLabel = isDark ? "Dark mode" : "Light mode";
  const actionLabel = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <button
      type="button"
      onClick={toggleMode}
      role="switch"
      aria-checked={isDark}
      aria-label={`${actionLabel}. Currently ${currentLabel.toLowerCase()}.`}
      title={actionLabel}
      className="inline-flex h-9 w-9 items-center justify-center rounded-none border border-transparent text-ink-secondary hover:text-primary hover:border-primary/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:border-primary transition-colors"
    >
      <span className="sr-only">{actionLabel}</span>
      {isDark ? (
        <Moon className="size-4" aria-hidden="true" focusable="false" />
      ) : (
        <Sun className="size-4" aria-hidden="true" focusable="false" />
      )}
    </button>
  );
}

